import React from "react";
import { useTranslation } from "react-i18next";
import * as S from "./style";

function Banner() {
  const { t } = useTranslation("common");

  return (
    <S.Container>
      <div>
        <div className="text text-animation">{t("BANNER_TEXT")} </div>{" "}
        <div className="text text-animation1">
          <div className="text-modified">
            {t("BANNER_TEXT1")}
            <span>{t("BANNER_TEXT2")}</span>
          </div>
          <div>
            <span>&nbsp;{t("BANNER_TEXT3")}</span>
          </div>
        </div>
        {/* <span>&nbsp;발견하다.</span> */}
      </div>
    </S.Container>
  );
}

export default Banner;
